const ArrowDropUp = ({ size = 25, fill = 'black' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.21005 12.2902L11.8001 9.70021C12.1901 9.31021 12.8201 9.31021 13.2101 9.70021L15.8001 12.2902C16.4301 12.9202 15.9801 14.0002 15.0901 14.0002H9.91005C9.02005 14.0002 8.58005 12.9202 9.21005 12.2902Z"
        fill={fill}
        fillOpacity="0.54"
      />
    </svg>
  );
};

export default ArrowDropUp;
